// Toast configuration with icon mappings and styling
export const TOAST_CONFIG = {
  danger: {
    icon: 'fa-warning',
    color: 'danger',
    position: 'bottom-left',
  },
  warning: {
    icon: 'fa-exclamation-circle',
    color: 'warning',
    position: 'bottom-left',
  },
  primary: {
    icon: 'fa-info-circle',
    color: 'primary',
    position: 'bottom-left',
  },
  success: {
    icon: 'fa-check',
    color: 'success',
    position: 'bottom-left',
  },
  'voice-detected': {
    icon: 'fa-microphone',
    color: 'voice-detected',
    position: 'bottom-left',
    customLayout: true,
    title: 'Voice Detected!',
    message:
      'Speaking or background noise may be treated as a violation and reported to the test administrator. Continue only from a silent environment.',
  },
};

// Default toast configuration
export const DEFAULT_TOAST_CONFIG = {
  icon: 'fa-info-circle',
  color: 'primary',
  position: 'bottom-left',
  customLayout: false,
};
